import { styled } from '@mui/material';

const CustomInput = styled('input')(({ theme }) => ({
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.secondary.contrastText
      : theme.palette.secondary.neutral_10,
  padding: theme.spacing(4, 6),
  border: `1px solid ${theme.palette.secondary.neutral_80}`,
  backgroundColor: theme.palette.secondary.paper,
  fontSize: theme.spacing(4),
  fontWeight: 400,
  borderRadius: theme.spacing(2),
  outline: 'none',
  width: '100%',
  fontFamily: 'Poppins, sans-serif !important',
  '&::placeholder': {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.secondary.neutral_80
        : theme.palette.secondary.neutral_50,
  },

  '&:focus': {
    border: `1px solid ${theme.palette.secondary.main}`,
  },
  '&:disabled': {
    color: `${theme.palette.primary.primary_95} !important`,
    '-webkit-text-fill-color': `${theme.palette.primary.primary_95} !important`,
    border: `1px solid ${theme.palette.secondary.neutral_100}`,
    backgroundColor: theme.palette.primary.primary_100,
    cursor: 'not-allowed',
  },
  '&.error': {
    border: `1px solid ${theme.palette.error.main}`,
    '&:focus': {
      border: `1px solid ${theme.palette.error.main}`,
    },
  },
  '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
    WebkitBoxShadow: `0 0 0 ${theme.spacing(250)} ${theme.palette.secondary.paper} inset !important`,
    WebkitTextFillColor: `${
      theme.palette.mode === 'dark'
        ? theme.palette.secondary.contrastText
        : theme.palette.secondary.neutral_10
    } !important`,
    transition: 'background-color 5000s ease-in-out 0s',
  },
  [theme.breakpoints.down('xl')]: {
    padding: theme.spacing(3.5, 5.5),
    fontSize: theme.spacing(3.75),
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: theme.spacing(3.5),
    padding: theme.spacing(3, 5),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3, 5),
    fontSize: theme.spacing(3.5),
  },
}));

const BaseInput = ({
  type = 'text',
  placeholder = '',
  onChange = '',
  value = '',
  ErrorInput = false,
  name = '',
  sx = {},
  onBlur = '',
  disabled = false,
}) => {
  return (
    <>
      <CustomInput
        type={type}
        placeholder={placeholder}
        onChange={
          onChange
            ? onChange
            : () => {
                return;
              }
        }
        value={value}
        className={ErrorInput ? 'error' : null}
        name={name}
        onBlur={
          onBlur
            ? onBlur
            : () => {
                return;
              }
        }
        disabled={disabled}
      ></CustomInput>
    </>
  );
};
export default BaseInput;
